






import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class AppAlertsNewVersion extends Vue {
  logout() {
    window.sessionStorage.removeItem('impersonation'); 
    window.location.reload();
  }
}
